import { costOfNotAutomating } from '../../data/content';
import './CostOfNotAutomating.css';

function CostOfNotAutomating() {
  return (
    <section id="custo" className="section cost-section">
      <div className="container">
        <div className="section-header">
          <h2>Quanto custa <span className="text-danger">NÃO</span> automatizar?</h2>
          <p>Cada dia com processos manuais tem um preço — e ele cresce com o tempo.</p>
        </div>

        <div className="cost-grid">
          {costOfNotAutomating.map((item) => (
            <div key={item.role} className="cost-card">
              <h3>{item.role}</h3>
              <p>{item.impact}</p>
            </div>
          ))}
        </div>

        <p className="cost-conclusion">
          Automatizar normalmente custa <strong>menos</strong> do que continuar perdendo tempo.
        </p>
      </div>
    </section>
  );
}

export default CostOfNotAutomating;
